module.exports = __webpack_public_path__ + "media/bootstrap-icons/stoplights-fill-bca6abdf.svg";